import type { UseStepEmployeeProps } from "../types/hooks";
import { useTable } from "./useTable";
import { useToolbar } from "./useToolbar";

const useStepEmployee = ({ t, activeStep, period }: UseStepEmployeeProps) => {
  const toolbarProps = useToolbar({ activeStep });
  const tableProps = useTable({
    t,
    employees: toolbarProps.employees,
    setLoading: toolbarProps.setLoading,
    period,
    filter: toolbarProps.filter,
  });

  return { ...toolbarProps, ...tableProps };
};

export { useStepEmployee };
